import React from 'react';
import { Chart as ChartJS, ArcElement, Title,Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

// const options = {
//   type: 'doughnut',
//   data: data,
//   options: {
//     animation: {
//         delay:0
//     },
//     animations: {
//         animateRotate: true,
//     },
//     borderColor: 'rgba(255, 255, 255,1)',
//     borderWidth:5,
//     offset:3,
//     hoverBorderWidth:0,
//     spacing: 0,
//     hoverOffset:25,
//     weight:5,
//     // clip: {left: 5, top: 15, right: -2, bottom: 0},
//     animations: {
//         animateScale: true
//     },
//     responsive: true,
//     layout: {
//         padding:50
//     },
//     plugins: {
//       legend: {
//         display: true,
//         position: 'top',
//         labels: {
//             color: 'rgb(255,255,255)',
//             padding:40,
//             boxWidth:10,
//             boxHeight:10,
//             font: {
//                 size: 16,
//                 lineHeight: 2
//             },
//         },
//       },
//       title: {
//         display: false,
//         text: 'Chart.js Bar Chart'
//       }
//     }
//   },
// };
export const options = {
  maintainAspectRatio: true,

  hoverOffset: 4,
        plugins: {
    title: {
      display: true,
      text: '',
      color: 'rgb(255,255,255)',
      font: {
        size: 20,
        lineHeight: 2,
        family: 'good-times',
        weight: '400',

      },
    },
    legend: {
      display: true,
      position: 'bottom',
      labels: {
          color: 'rgba(66, 173, 241, 1.0)',
          padding:35,
          boxWidth:15,
          boxHeight:10,
          font: {
              size: 16,
              lineHeight: 2,
              family: 'brother-1816',
              weight: '300',
          },
      },
    },
  responsive: true,
}
};

export const data = {
  labels: [ 'Airdrop Rewards',
  'Liquidity',
  'LP Farming Rewards'],
  datasets: [
    {
      label: 'Token Allocation',
      data: [25,50,25],
      backgroundColor: [
        'rgba(107,228,247, 0.85)',
        'rgba(54, 162, 235, 0.9)',
        'rgba(255, 255, 255, 0.95)'
      ],
      borderColor: [
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)',
        'rgba(255, 255, 255, 1)'
      ],
      borderWidth: 1,
      hoverOffset: 4,
      hoverBorderWidth:0,
    spacing: 0,
    hoverOffset:25,
    weight:5,
    },
  ],
};




    export default function Chart() {
      return (
          <Doughnut 
          height={500} 
          data={data} 
          options={options} 
          />
      );
    }
